import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, errMsg } from "@/lib/api";
import { TrxLogo, UsdtLogo } from "@/components/CryptoLogos";

const GROUPS = [
  { title: "Site Ayarları", fields: [
    ["site_name", "Site Adı (logo)", "text", true],
    ["meta_title", "Meta Başlık (tarayıcı sekmesi)", "text", true],
    ["meta_description", "Meta Açıklama", "text", true],
  ] },
  { title: "Kripto (TRC20)", icon: <div className="flex -space-x-1.5"><TrxLogo size={22} /><UsdtLogo size={22} /></div>, fields: [
    ["trc20_address_trx", "TRON (TRX) Cüzdan Adresi", "text", true],
    ["trc20_address_usdt", "USDT (TRC20) Cüzdan Adresi", "text", true],
    ["rate_usdt", "1 USDT = ? ₺ (yedek — canlı kur çalışmazsa)", "number"],
    ["rate_trx", "1 TRX = ? ₺ (yedek — canlı kur çalışmazsa)", "number"],
    ["crypto_timeout_minutes", "Ödeme Süresi (dk)", "number"],
    ["crypto_deposit_bonus_percent", "Çevrimsiz Kripto Yatırım Bonusu (%, anında)", "number"],
  ] },
  { title: "Havale / EFT", fields: [
    ["bank_name", "Banka Adı", "text"],
    ["bank_holder", "Ad Soyad", "text"],
    ["bank_iban", "IBAN", "text", true],
    ["bank_timer_minutes", "Ödeme Sayacı (dk)", "number"],
  ] },
  { title: "Limitler & Ortaklık", fields: [
    ["min_deposit", "Min. Yatırım (₺)", "number"],
    ["min_withdraw", "Min. Çekim (₺)", "number"],
    ["affiliate_percent", "Ortaklık Komisyonu (%)", "number"],
    ["auto_lossback_percent", "Çevrimsiz Kayıp Bonusu (%, her kayıpta anında)", "number"],
  ] },
];

export const AdminPayment = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    adminApi.get("/admin/settings").then((r) => setS(r.data));
  }, []);
  if (!s) return null;

  const save = async () => {
    try {
      const body = {};
      GROUPS.forEach((g) => g.fields.forEach(([k, , t]) => (body[k] = t === "number" ? Number(s[k]) : s[k])));
      const { data } = await adminApi.put("/admin/settings", body);
      setS(data);
      toast.success("Ayarlar kaydedildi");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="space-y-4 max-w-3xl">
      {GROUPS.map((g) => (
        <div key={g.title} className="x-panel p-5">
          <div className="font-extrabold mb-4 flex items-center gap-2">{g.icon}{g.title}</div>
          <div className="grid sm:grid-cols-2 gap-4">
            {g.fields.map(([k, label, type, wide]) => (
              <div key={k} className={wide ? "sm:col-span-2" : ""}>
                <label className="x-label">{label}</label>
                <input data-testid={`setting-${k}`} type={type} step="any" className={`x-input ${wide ? "font-mono" : ""}`} value={s[k] ?? ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} />
              </div>
            ))}
          </div>
        </div>
      ))}
      <button data-testid="payment-settings-save-btn" onClick={save} className="x-btn x-btn-primary w-full">Kaydet</button>
    </div>
  );
};
